import { ERD, SubscriptionActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  SUBSCRIPTION_ENDPOINTS_URLS,
  SUBSCRIPTION_TAGS,
} from "./api-subscription.constant";

export const {
  useCreateSubscriptionMutation,
  useRenewSubscriptionMutation,
  useReadManySubscriptionsQuery,
  useReadUserSubscriptionQuery,
  useUpdateSubscriptionStatusMutation,
  useDeleteSubscriptionMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createSubscription: builder.mutation<
      ERD<SubscriptionActions["create"]>,
      QueryArgsNew<SubscriptionActions["create"]>
    >({
      query: ({ payload }) => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
    renewSubscription: builder.mutation<
      ERD<SubscriptionActions["create"]>,
      QueryArgsNew<SubscriptionActions["create"]>
    >({
      query: ({ payload }) => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.renew,
        method: "post",
        payload,
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
    readManySubscriptions: builder.query<
      ERD<SubscriptionActions["readMany"]>,
      QueryArgsNew<SubscriptionActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
    readUserSubscription: builder.query<
      ERD<SubscriptionActions["readUserSubscription"]>,
      void
    >({
      query: () => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.readUserSubscription,
        method: "get",
      }),
      providesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
    updateSubscriptionStatus: builder.mutation<
      void,
      QueryArgsNew<SubscriptionActions["updateStatus"]>
    >({
      query: ({ payload, params }) => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.updateStatus(params),
        method: "put",
        payload,
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
    deleteSubscription: builder.mutation<
      void,
      QueryArgsNew<SubscriptionActions["delete"]>
    >({
      query: ({ params }) => ({
        url: SUBSCRIPTION_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.subscription],
    }),
  }),
});
